import { createAction, createReducer } from "@reduxjs/toolkit";

export const addNewMoat = createAction('addNewMoat')
export const setMoatIndex = createAction('moatIndex')
export const resetAddNewMoat = createAction('resetAddNewMoat')
export const resetSetMoatIndex = createAction('resetSetMoatIndex')

const initialState = {
    value: "",
    index: ""
};

export const moatNameSlices = createReducer(initialState, {
    [addNewMoat]: (state, action) => {
        state.value = action.payload
    },
    [setMoatIndex]: (state, action) => {
        state.index = action.payload
    },
    [resetAddNewMoat]: (state, action) => {
        state.value = initialState
    },
    [resetSetMoatIndex]: (state, action) => {
        state.index = initialState
    }
}
);

//used in:
// createmoat - addNewMoat is used to take a newly created moat and assign it to the globally stored moatName slice
// home - takes the return of the getMoat query to Kwil API and stores in global state variable
// Takeaway: this is prob an okay way to store it, but using addNewMoat in createmoat is potentially reduandant if there is a variable that tracks changes in the moat. Also would need to add a spread operator.
// --> Need to fix the useEffect function in home. It is currently refreshing with every re-render


